// node_modules
import React from "react";

// @primereact
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

// styles
import * as styles from "./MobileSelectModal.module.css";

export const MobileSelectModalFooter = ({ onSave, onCancel }) => {
  return (
    <div className={styles.buttonsContainer}>
      <Button
        className={classNames(styles.button, styles.buttonSave)}
        label="Save"
        onClick={onSave}
      />

      <Button
        className={classNames(styles.button, styles.buttonCancel)}
        label="Cancel"
        onClick={onCancel}
      />
    </div>
  );
};
